import formStyles from './Form.module.css';

function Alert({
  message,
  children = null,
  theme = {},
  type = 'error',
}: {
  message?: string;
  children?: React.ReactNode;
  theme?: Record<string, string>;
  type?: 'error' | 'info' | 'success' | 'warning';
}) {
  if (!message && !children) {
    return null;
  }

  const cssClass = `${type}Alert`;
  return (
    <div
      className={
        theme[cssClass] || formStyles[cssClass] || formStyles.infoAlert
      }
    >
      {message || children}
    </div>
  );
}

export default Alert;
